// extracted by mini-css-extract-plugin
export default {"wrap":"_b8362977","itemId":"_a24b203b"};